import messages from '../../constants/logMessages.json';
import tracking from '../../tracking/tracking';
import { AnalyticsConst } from '../../types';
import { ClickPayload, inputFieldPayload } from '../../types/designSystem';
import { jsonToString } from '../analyticsUtils';
import { checkForPII } from '../helpers';
import logging, { getMessage } from '../logging';

const { errorHeading, errorBold } = messages;

type ButtonLinkPayload = ClickPayload;

export const buttonAndLinkHandler = ({
  data,
  trackProps,
  componentType,
  action,
}: ButtonLinkPayload) => {
  try {
    const { variant, version } = trackProps;
    let { label } = trackProps;

    // PII suppress.
    if (label) label = checkForPII(label) as string;

    const trackObject = {
      event: 'et_click',
      eventAction: label ? label.toLowerCase() : AnalyticsConst.NOT_SET,
      eventLabel: label || AnalyticsConst.NOT_SET,
      trackProps: {
        ...trackProps,
        adsComponent: `${version}|${componentType}|${variant}`,
        action,
      },
      data,
    };

    tracking.analyticsEngagementTracking(trackObject);
  } catch (e) {
    logging.error(
      getMessage('catchError', [
        'Engagement Tracking Click',
        jsonToString([e as object]),
      ]),
      errorHeading,
      errorBold
    );
  }
};

export const showAndCloseHandler = ({
  data,
  trackProps,
  componentType,
  // action,
}: ButtonLinkPayload) => {
  try {
    const { status, variant, version } = trackProps;

    let { label } = trackProps;

    // PII suppress.
    if (label) label = checkForPII(label) as string;

    const trackObject = {
      event: `et_${status === 'active' ? 'show' : 'close'}`,
      eventAction: label ? label.toLowerCase() : AnalyticsConst.NOT_SET,
      eventLabel: label || AnalyticsConst.NOT_SET,
      trackProps: {
        ...trackProps,
        adsComponent: `${version}|${componentType}|${variant}`,
        action: status ? 'show' : 'close',
      },
      data,
    };

    tracking.analyticsEngagementTracking(trackObject);
  } catch (e) {
    logging.error(
      getMessage('catchError', [
        'showAndCloseHandler',
        jsonToString([e as object]),
      ]),
      errorHeading,
      errorBold
    );
  }
};

export const datePickerButtonHandler = ({
  data,
  trackProps,
  componentType,
  action,
}: inputFieldPayload) => {
  try {
    const { variant, version } = trackProps;
    const { label = '', fieldName = '', behaviour = '' } = trackProps;

    // // PII suppress.
    // if (label && !checkForPII(label)) label = 'mask';

    const trackObject = {
      event: 'et_click',
      eventAction: `${fieldName}: ${behaviour}`,
      eventLabel: label || AnalyticsConst.NOT_SET,
      trackProps: {
        ...trackProps,
        adsComponent: `${version}|${componentType}|${variant}`,
        action,
      },
      data,
    };

    tracking.analyticsEngagementTracking(trackObject);
  } catch (e) {
    logging.error(
      getMessage('catchError', [
        'datePickerButtonHandler',
        jsonToString([e as object]),
      ]),
      errorHeading,
      errorBold
    );
  }
};
